import * as GC from '@grapecity/spread-sheets';

export const resumeAll = (sheet: GC.Spread.Sheets.Worksheet, origin: string = null): boolean | void => {
  if (sheet) {
    const suspendState = sheet.isPaintSuspended();
    if (suspendState) {
      sheet.resumeCalcService();
      sheet.resumeEvent();
      sheet.resumePaint();
      // console.log(`✅ Resumed ${origin ? origin : ''}`);
    }
    return suspendState;
  }
};
